import { UserManager, WebStorageStateStore } from 'oidc-client';
import { CONFIG } from '../config';
import templates from '../scripts/core/templates';
import { translate } from '../scripts/core/tools/translate';
import {destroyIntercom} from '../helpers/intercom.helper';

export class AuthService {
    userManager;
    dialog = null;
    template = null;

    constructor() {
        const settings = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: CONFIG.URL.IDENTITY_SERVER_URL,
            client_id: CONFIG.NEOGIG_CLIENT_ID,
            redirect_uri: `${CONFIG.URL.NEOGIG_HOST}/#/callback`,
            response_type: 'code',
            scope: 'openid profile Neocom.Neogig.Api Neocom.Neodash.Api Neocom.ControlPanel.Api',
            post_logout_redirect_uri: `${CONFIG.URL.NEOGIG_HOST}`,
            popup_redirect_uri: `${CONFIG.URL.NEOGIG_HOST}/#/callback/popup`
        };
        this.userManager = new UserManager(settings);
    }

    getUser() {
        return this.userManager.getUser();
    }

    login() {
        const params = new URLSearchParams(window.location.search);
        let queryParams = {};

        if (params.has('intercom_survey_id')) {
            queryParams = {
                extraQueryParams: {
                    intercom_survey_id: params.get('intercom_survey_id')
                }
            };
        }

        return this.userManager.signinRedirect(queryParams);
    }

    logout() {
        destroyIntercom();
        return this.userManager.signoutRedirect();
    }

    signinPopup() {
        if (!this.dialog) {
            this.showSessionExpired();

            return this._popupNotBlocked()
                .then(() => this.userManager.signinPopup())
                .then(user => {
                    sessionStorage.setItem('username', user.profile.given_name);
                    sessionStorage.setItem('token', user.access_token);
                    sessionStorage.setItem('tokenType', user.token_type);
                    sessionStorage.setItem('expires', new Date(user.expires_at));

                    this.hideSessionExpired();
                    return true;
                })
                .catch(err => {
                    this._showMessagePopupBlocked();
                });
        }
    }

    showSessionExpired() {
        this._createSessionExpiredDialog();
        this.dialog.center().open();
    }

    hideSessionExpired() {
        this.dialog.close();
        this.dialog.destroy();
        this.template.remove();
        this.dialog = null;
    }

    async getAccessToken() {
        return await this.userManager.getUser().then(user => {
            return user != null ? user.access_token : this.signinPopup();
        });
    }

    getAccessTokenHeader() {
        return {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
        };
    }

    revokeAccessToken() {
        return this.userManager.revokeAccessToken();
    }

    isAuthenticated() {
        return this.userManager.getUser().then(user => {
            if (user !== null) {
                sessionStorage.setItem('username', user.profile.given_name);
                sessionStorage.setItem('token', user.access_token);
                sessionStorage.setItem('tokenType', user.token_type);
                sessionStorage.setItem('expires', new Date(user.expires_at));

                return true;
            }

            return false;
        });
    }

    _createSessionExpiredDialog() {
        this.template = $(templates('dialog-login'));

        this.dialog = this.template
            .kendoWindow({
                width: '400px',
                resizable: false,
                draggable: false,
                visible: false,
                title: false,
                modal: true
            })
            .data('kendoWindow');
    }

    _popupNotBlocked() {
        return new Promise((resolve, reject) => {
            const winTester = window.open(null,"","width=0,height=0");
            if (!winTester || winTester.closed || typeof winTester.closed=='undefined') {
                reject();
            } else {
                if (!winTester.closed) {
                    winTester.close();
                }
                resolve();
            }
        });
    }

    _showMessagePopupBlocked() {
        const el = document.querySelector('.form-content');
        if (el) {
            el.style.display = "flex";
        }

        const elContainer = document.querySelector('.k-widget.k-window.k-window-titleless');
        if (elContainer) {
            elContainer.style.top = '350px';
        };
    }
}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/services/authservice.js